import * as React from 'react';

import { OptionsConsumer } from '../OptionsProvider';
import { StylingMarkdownProps } from './Markdown';
import { StyledMarkdownBlock } from './styled.elements';
import DOMPurify from 'dompurify';


const InlineStyledMarkdownBlock = StyledMarkdownBlock.withComponent('span');

export function SanitizedMarkdownHTML(
    props: StylingMarkdownProps & { html: string; className?: string; 'data-role'?: string }
) {
    const Wrap = props.inline ? InlineStyledMarkdownBlock : StyledMarkdownBlock;

    return (
        <OptionsConsumer>
            {() => (
                <Wrap
                    className={'redoc-markdown ' + (props.className || '')}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(props.html),
                    }}
                    data-role={props['data-role']}
                    {...props}
                />
            )}
        </OptionsConsumer>
    );
}
